import { useSelector } from "metabase/redux";
import { getUser } from "metabase/selectors/user";
import { checkNotNull } from "metabase/utils/types";

import { Sms2faForm } from "../../components/Sms2faForm";

const Sms2faApp = () => {
  const user = checkNotNull(useSelector(getUser));
  return <Sms2faForm user={user} />;
};

// eslint-disable-next-line import/no-default-export -- deprecated usage
export default Sms2faApp;
